import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { CircularProgress, Box } from '@mui/material';

const PrivateRoute = ({ requireProvider = false }) => {
  const { currentUser, loading } = useAuth();
  
  // Show loading spinner while auth state is being checked
  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress size={60} sx={{ color: '#F2C641' }} />
      </Box>
    );
  }
  
  // Check if user is logged in
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }
  
  // For provider-only routes, check if user has provider role
  if (requireProvider && currentUser.role !== 'provider') {
    return <Navigate to="/provider-application" replace />;
  }
  
  // User is authenticated, render the protected component
  return <Outlet />;
};

export default PrivateRoute; 